/**
 * custom-dashboard Agent の LLM コスト・運用確認ビュー APIクライアント（T-0042）
 */

import { AuthenticatedApiClient } from '../client';
import type {
  DashboardLlmCostJobLogUrlResponse,
  DashboardLlmCostResponse,
} from '@/lib/types/dashboard/llmCost';

/** 取得条件（backend の `LlmCostQueryParams` に対応） */
export interface DashboardLlmCostParams {
  start_date: string;
  end_date: string;
  /** day (既定) / week / month */
  granularity?: string;
  account_code?: string;
  tab_id?: string;
  /** succeeded / failed（省略時は両方） */
  status?: string;
}

/**
 * LLM コスト・運用メトリクスを取得（認証付き）
 */
export async function getDashboardLlmCostAuthenticated(
  authHeaders: Record<string, string>,
  params: DashboardLlmCostParams,
): Promise<DashboardLlmCostResponse> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    const queryParams = new URLSearchParams();
    queryParams.append('start_date', params.start_date);
    queryParams.append('end_date', params.end_date);
    if (params.granularity) queryParams.append('granularity', params.granularity);
    if (params.account_code) queryParams.append('account_code', params.account_code);
    if (params.tab_id) queryParams.append('tab_id', params.tab_id);
    if (params.status) queryParams.append('status', params.status);

    return await client.get<DashboardLlmCostResponse>(
      `/dashboard/llm-cost?${queryParams.toString()}`,
    );
  } catch (error) {
    console.error('Failed to fetch dashboard LLM cost:', error);
    throw error;
  }
}

/**
 * ジョブログ（Agent が S3 に書く JSON Lines）の presigned GET URL を取得（認証付き）。
 * ログが無いジョブ（preflight 失敗・ログ機能導入前・14 日経過）は 404 になる。
 */
export async function getDashboardLlmCostJobLogUrlAuthenticated(
  authHeaders: Record<string, string>,
  jobId: string,
): Promise<DashboardLlmCostJobLogUrlResponse> {
  const client = new AuthenticatedApiClient(authHeaders);
  return client.get<DashboardLlmCostJobLogUrlResponse>(
    `/dashboard/llm-cost/jobs/${encodeURIComponent(jobId)}/log`,
  );
}
